var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { staticClass: "module-viewer" }, [
    _vm.loading
      ? _c(
          "div",
          { staticClass: "module-loading-wrapper" },
          [
            _c("a-skeleton", {
              attrs: { active: true, paragraph: { rows: 8 }, title: "" },
            }),
          ],
          1
        )
      : _vm.currentModule
      ? _c(
          "div",
          { staticClass: "route-page-content" },
          [
            _c("SidebarChild", {
              attrs: { items: _vm.menuItems, focusActive: true },
              on: { selected: _vm.handleSidebarSelection },
            }),
            _vm._v(" "),
            _vm.selectedItem === "list"
              ? _c(
                  "div",
                  { staticClass: "module-page-content" },
                  [
                    _c("TableDetail", {
                      attrs: {
                        "default-table-id": _vm.currentModule.table,
                        moduleMode: true,
                        pageMode: true,
                        "selected-module": _vm.currentModule,
                      },
                    }),
                  ],
                  1
                )
              : _vm._e(),
          ],
          1
        )
      : _c("div", { staticClass: "not-found" }, [
          _c("h3", [
            _vm._v(_vm._s(_vm.$t("modulNotFound") || "Modül bulunamadı.")),
          ]),
        ]),
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }